export const SERVICE_TYPE_IDS: number[] = [31,32,33,34,35,36,37];
